import React, { Component } from 'react';
import './TagCloud.css'

export default class TagCloud extends Component {
  constructor(props) {
        super(props);
        this.state = {tags: []}
  }

  componentDidMount() {
    fetch(`${process.env.REACT_APP_API_URL}/randomTag/100`)
      .then(response => this.handleHTTPErrors(response))
      .then(response => response.json())
      .then(result => {
        this.setState(result);
      })
      .catch(error => {
        console.log(JSON.stringify(error));
      });
  }

  handleHTTPErrors(response) {
    if (!response.ok) throw Error(response.status + ': ' + response.statusText);
    return response;
  }

  render() {
    return (
      <div className="linkStyle">
        {this.state.tags.map(tag =>
        <a href={"/tag/"+tag}>{tag} </a>
        )}
      </div>
    )
  }
}
